import { Phone, Mail, Globe, Clock, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { FranceMap } from "./FranceMap";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO, WHATSAPP_URL } from "@/constants/site";

const WHY_ITEMS = [
    "Jusqu'à 450 € offerts",
    "Aucune avance de frais",
    "Toutes assurances",
    "Intervention rapide à domicile",
    "Garantie à vie",
    "Satisfaction client",
    "Équipe qualifiée et expérimentée",
];

const CONTACT_ROWS = [
    { icon: Phone, label: PHONE_DISPLAY, href: PHONE_TEL, testid: "zwc-phone" },
    { icon: Mail, label: EMAIL, href: EMAIL_MAILTO, testid: "zwc-email" },
    { icon: WhatsAppIcon, label: "WhatsApp", href: WHATSAPP_URL, testid: "zwc-whatsapp", external: true },
    { icon: Globe, label: "Toute la France", testid: "zwc-zone" },
    { icon: Clock, label: "7j/7 de 8h à 20h", testid: "zwc-hours" },
];

export const ZoneWhyContact = () => (
    <section data-testid="zone-why-contact-section" className="relative bg-white py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-3 gap-14 lg:gap-10">
            <Reveal>
                <h2 className="font-display font-extrabold uppercase tracking-wide text-2xl sm:text-3xl text-midnight-900">
                    Intervention partout en France
                </h2>
                <p className="mt-4 text-sm sm:text-base text-gray-500 leading-relaxed">
                    Nous nous déplaçons à domicile ou sur votre lieu de travail, partout en France.
                </p>
                <div className="mt-10">
                    <FranceMap />
                    <p className="mt-4 text-xs text-gray-400 text-center">
                        Intervention à domicile dans les grandes villes et partout en France.
                    </p>
                </div>
            </Reveal>

            <Reveal delay={0.12}>
                <h2 className="font-display font-extrabold uppercase tracking-wide text-2xl sm:text-3xl text-midnight-900">
                    Pourquoi choisir <span className="text-gold-dark">Pare Brise Paris</span> ?
                </h2>
                <ul className="mt-8 space-y-4">
                    {WHY_ITEMS.map((item, i) => (
                        <li key={item} data-testid={`why-item-${i}`} className="flex items-center gap-3 text-sm sm:text-base font-medium text-midnight-800">
                            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-gold/15 border border-gold/70 text-gold-dark shrink-0">
                                <Check size={13} strokeWidth={3} />
                            </span>
                            {item}
                        </li>
                    ))}
                </ul>
            </Reveal>

            <Reveal delay={0.24}>
                <div className="rounded-2xl border border-gold/40 bg-midnight-800 p-8 flex flex-col gap-5 shadow-[0_25px_60px_rgba(10,14,23,0.25)]">
                    {CONTACT_ROWS.map((row) => {
                        const content = (
                            <>
                                <row.icon size={18} className="text-gold shrink-0" />
                                <span>{row.label}</span>
                            </>
                        );
                        return row.href ? (
                            <a
                                key={row.testid}
                                data-testid={row.testid}
                                href={row.href}
                                {...(row.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                className="flex items-center gap-3.5 text-sm sm:text-base font-medium text-gray-200 transition-colors duration-300 hover:text-gold"
                            >
                                {content}
                            </a>
                        ) : (
                            <div key={row.testid} data-testid={row.testid} className="flex items-center gap-3.5 text-sm sm:text-base font-medium text-gray-200">
                                {content}
                            </div>
                        );
                    })}
                    <a
                        data-testid="zwc-call-cta"
                        href={PHONE_TEL}
                        className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-gold-dark via-gold to-gold-light px-6 py-3.5 font-bold uppercase tracking-wide text-sm text-midnight-900 transition-transform duration-300 hover:scale-[1.03] active:scale-95"
                    >
                        <Phone size={17} strokeWidth={2.5} />
                        Appelez-nous
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
